var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeltplads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#021e3a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.807,11.943l-4.634-7.9L8.96,2.672a.314.314,0,0,0-.544-.313L7.807,3.417v0l-.012.021-.62-1.077a.314.314,0,0,0-.544.313l.8,1.387L2.784,11.943a.167.167,0,0,0,.143.251H5.569a.167.167,0,0,0,.146-.087L7.257,9.261a.616.616,0,0,1,1.084,0l1.534,2.844a.166.166,0,0,0,.146.088h2.642A.167.167,0,0,0,12.807,11.943Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeltplads);
export default __webpack_public_path__ + "static/media/TELTPLADS.7e56d10fd9ae9fd0f91dbc7d3aee7564.svg";
export { ForwardRef as ReactComponent };